module.exports = __webpack_public_path__ + "img/sevenday1-3.15573381.jpg";